document.addEventListener('DOMContentLoaded', function() {
  const inchesBtn = document.querySelector('.text-inches');
  const cmBtn = document.querySelector('.text-cm');
  const measurements = document.querySelectorAll('li.measurements');

  if (!inchesBtn || !cmBtn || measurements.length === 0) return;

  function showInches() {
    inchesBtn.classList.add('active');
    cmBtn.classList.remove('active');

    measurements.forEach(item => {
      const inchesSpan = item.querySelector('span.inches');
      const cmSpan = item.querySelector('span.cm');
      if (inchesSpan) inchesSpan.style.display = 'inline';
      if (cmSpan) cmSpan.style.display = 'none';
    });
  }

  function showCm() {
    cmBtn.classList.add('active');
    inchesBtn.classList.remove('active');

    measurements.forEach(item => {
      const inchesSpan = item.querySelector('span.inches');
      const cmSpan = item.querySelector('span.cm');
      if (inchesSpan) inchesSpan.style.display = 'none';
      if (cmSpan) cmSpan.style.display = 'inline';
    });
  }

  // Attach event listeners
  inchesBtn.addEventListener('click', showInches);
  cmBtn.addEventListener('click', showCm);

  // Initialize: show inches by default
  showInches();
});
